<template>
  <!-- Modal 1 Plus-->
  <div class="modal fade" id="aptamil1-plus" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-4">
              <h3>Aptamil 1+</h3>
              <p class="text-center">Formulă pentru copii <br>de vârstă mică 1 an+, 800g</p>
              <img class="img-fluid" src="../../../assets/images/pentru-imunitate/1+.png">
            </div>
            <div class="col-lg-8">
              <div class="scroll-vertical-band">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="home1plus-tab" data-toggle="tab"
                       href="#home1plus" role="tab" aria-controls="home1plus" aria-selected="true">Listă
                      ingrediente</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="profile1plus-tab" data-toggle="tab" href="#profile1plus"
                       role="tab" aria-controls="profile1plus" aria-selected="false">Ghid de
                      alimentație</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="contact1plus-tab" data-toggle="tab" href="#contact1plus"
                       role="tab" aria-controls="contact1plus" aria-selected="false"> Declarație
                      nutrițională</a>
                  </li>
                </ul>
              </div>
              <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="home1plus" role="tabpanel"
                     aria-labelledby="home1plus-tab">
                  <p>Lactoză (din <strong>lapte</strong> de vacă), galacto-oligozaharide (din <strong>lapte</strong> de vacă), concentrat de zer (din <strong>lapte</strong> de vacă), <strong>lapte</strong> de vacă degresat, ulei de floarea-soarelui, ulei de rapiță, fosfat tricalcic, fructo-oligozaharide, carbonat de calciu, ulei de <strong>pește</strong>, acid L-ascorbic, emulsifiant (lecitine (floarea-soarelui)), sulfat feros, antioxidant (ascorbil palmitat), acetat de retinil, riboflavină, iodură de potasiu, colecalciferol, cianocobalamină.</p>
                </div>
                <div class="tab-pane fade" id="profile1plus" role="tabpanel"
                     aria-labelledby="profile1plus-tab">
                  <ol>
                    <li>Spală-te bine pe mâini, sterilizează toate ustensilele utilizate în prepararea laptelui și asigură-te că marginea ambalajului este curată.</li>
                    <li>Fierbe apa potabilă pentru prepararea laptelui timp de 5 minute, apoi lasă la răcit până la cca 40°C. Toarnă în recipientul pregătit (biberon/cănuță) cantitatea de apă fiartă şi răcită, necesară conform dozării pentru o masă.</li>
                    <li>Dozează pudra cu linguriţa din capacul ambalajului, nivelată cu ajutorul marginii din interiorul cutiei. Adaugă pudra conform tabelului de dozare în recipientul pregătit (biberon/cănuță).</li>
                    <li>Închide recipientul şi agită vertical și viguros timp de 10 secunde. Este foarte important să respecți modalitatea și timpul de agitare pentru a dizolva corect pudra.</li>
                    <li>Verifică pe încheietura mâinii tale temperatura laptelui preparat (cca 37°C).</li>
                  </ol>
                </div>
                <div class="tab-pane fade box-shadow" id="contact1plus" role="tabpanel"
                     aria-labelledby="contact1plus-tab">
                  <div class="row height-row">
                    <div class="col-md-4 col-4 border-table">
                      <span class="span-black pl-0">Declarație nutrițională</span>
                    </div>
                    <div class="col-md-4 col-4 border-table">
                      <span class="span-black">100 g pudră</span>
                    </div>
                    <div class="col-md-4 col-4 border-table border-last">
                      <span class="span-black">la 100 ml produs reconstituit (15.4 g pudră)</span>
                    </div>
                  </div>

                  <valoare></valoare>
                  <grasimi></grasimi>
                  <glucide></glucide>
                  <fibre></fibre>
                  <proteine></proteine>
                  <sare></sare>
                  <vitamine></vitamine>
                  <alte></alte>
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Grasimi from "./Table/grasimi";
import Valoare from "./Table/valoare";
import Glucide from "./Table/glucide";
import Fibre from "./Table/fibre";
import Proteine from "./Table/proteine";
import Sare from "./Table/sare";
import Vitamine from "./Table/vitamine";
import Alte from "./Table/alte";

export default {
  components: {
    Grasimi,
    Valoare,
    Glucide,
    Fibre,
    Proteine,
    Sare,
    Vitamine,
    Alte,
  },
  data() {
    return {}
  },
}
</script>
